<template>
  <div>
    <div class="font-weight mb-10">选择应用</div>
    <el-select v-model="selectApp" value-key="id" clearable size="small" @change="handleAppChange">
      <el-option
          v-for="item in appList"
          :key="item.id"
          :label="item.refAppName + '(' + item.refAppVersion + ')'"
          :value="item.refAppId"
      ></el-option>
    </el-select>
    <div class="font-weight mt-10 mb-10">选择功能点</div>
    <el-select v-model="selectAction" filterable value-key="id" clearable size="small" @change="handleActionChange">
      <el-option v-for="item in actionList" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script setup>
import {ref, reactive, computed, watch, inject, unref} from "vue";
import {useCommonMix} from "@/option/common/commonmix";
import {commonDao, bizPath, sceneDao} from "@/option/common/dao";
import {ACTION_TYPE, DATA_SOURCE_TYPE} from "@/option/common/dict.js";

let props = defineProps({
  showSelect: {
    default: true,
  },
  filterSelected: {
    default: true,
  },
  modelValue: {},
  option: {},
  // 是否隐藏页面应用
  hidePageSelect: {
    type: Boolean
  }
});
const emit = defineEmits(["select", "close"]);
const {confirm, success, warning, error} = useCommonMix();
defineExpose({});
let appInstance = inject("appInstance", {});
let getApp = inject('getApp', null)
let app = getApp ? getApp() : inject("app")
let depends = app.deptList
let appList = computed(() => {
  if (props.hidePageSelect) {
    return depends
  }
  return depends.concat([{refAppName: app.name, refAppVersion: app.version, refAppId: app.id}]);
});

// 选择功能点的参数
let selectApp = ref(null);
let selectAction = ref(null);
let metricsParams = ref([]);
let dimensionsParams = ref([]);
let queryParams = ref([]);
let actionList = ref([]);

function handleClose() {
  emit("close");
}

// 切换图表组件重新清空数据
watch(
    () => props.option.ref,
    () => {
      selectApp.value = null;
      selectAction.value = null;
      actionList.value = [];
    },
);

function handleAppChange(v) {
  let refApp = appList.value.find((el) => el.refAppId === v);
  return commonDao
      .list(bizPath.standerAction, {
        appId: refApp.refAppId,
        version: refApp.refAppVersion,
        actionType: ACTION_TYPE.STATISTIC,
      })
      .then((res) => {
        selectAction.value = null;
        metricsParams.value = [];
        dimensionsParams.value = [];
        queryParams.value = [];
        actionList.value = res;
      });
}

function handleActionChange(v) {
  if (!v) return;
  let action = actionList.value.find((el) => el.id === v);
  sceneDao
      .getParamsByActionId({
        id: action.id,
        appId: action.appId,
        version: action.version,
      })
      .then((res) => {
        metricsParams.value =
            res.kpiList?.map((el) => {
              return {
                ...el,
                selected: true,
              };
            }) ?? [];
        dimensionsParams.value =
            res.dimList?.map((el) => {
              return {
                ...el,
                selected: true,
              };
            }) ?? [];
        queryParams.value =
            res.filterList?.map((el) => {
              return {
                ...el,
                selected: true,
              };
            }) ?? [];

        handleSelectAction(v);
      });
}

if (props.modelValue.queryAction) {
  selectApp.value = props.modelValue.queryAction.appId;
  handleAppChange(selectApp.value).then(() => {
    selectAction.value = props.modelValue.queryAction.actionId;
  });
}

function handleSelectAction(sv) {
  let v = actionList.value.find((el) => el.id === sv);
  appInstance?.setActionItem && appInstance?.setActionItem(v.id, v.appId, v.version);
  props.modelValue.queryAction = {
    actionId: v.id,
    appId: v.appId,
    version: v.version,
    actionName: v.name,
    actionContent: v.actionContent,
    type: v.serviceType,
    actionType: v.actionType,
  };
  props.modelValue.dataSourceType = DATA_SOURCE_TYPE.BIZ;
  emit("select", v, convertData(metricsParams.value), convertData(dimensionsParams.value), convertData(queryParams.value));
}

function convertData(params) {
  return params.map((p) => {
    return p;
  });
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.dialog-wrap {
  height: 50vh;
  overflow: auto;
  padding-right: $gap;
}

.param-title {
  margin: $gap 0;
  font-size: $titleFont;
  font-weight: 700;
}

.btn-wrap {
  margin: $gap;
  text-align: center;
}
</style>
